import React from "react";

const Content = ({ children }) => {
  return <div className="right_bar">{children}</div>;
};

export default Content;
